import React from "react";
import { Box, Button, Typography } from "@mui/material";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import { useTranslation } from "react-i18next";

interface MobilePhlebotomyRequestCardProps {
  onRequest: () => void;
}

const MobilePhlebotomyRequestCard: React.FC<
  MobilePhlebotomyRequestCardProps
> = ({ onRequest }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        // Soft content block (no outline) so it doesn't read as header chrome.
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        gap: 0.75,
        p: 0.75,
        width: "100%",
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ display: "flex", gap: 0.75, minWidth: 0 }}>
        <MedicalServicesOutlinedIcon
          sx={{
            flexShrink: 0,
            mt: 0.125,
            fontSize: 18,
            color: (theme) => theme.palette.custom.redMedium,
          }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle2"
            component="h2"
            sx={{ fontSize: 13.5, lineHeight: 1.2 }}
          >
            {t("phlebotomySearch.mobileRequest.cardTitle")}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: 12, lineHeight: 1.25 }}
          >
            {t("phlebotomySearch.mobileRequest.cardSupport")}
          </Typography>
        </Box>
      </Box>
      <Button
        // Same outline treatment as location-card actions: Call red on
        // text + border (secondary/outline, not filled primary).
        variant="unity-outline-orange"
        size="small"
        sx={{ minHeight: 32, py: 0.25 }}
        onClick={onRequest}
      >
        {t("phlebotomySearch.mobileRequest.cardAction")}
      </Button>
    </Box>
  );
};

export default MobilePhlebotomyRequestCard;
